import { t } from '@lingui/macro';
import { UserAdminTab, UserAdminTabType } from './types';

export const UserAdminTabList: UserAdminTab[] = [
  { label: t`Edit Users`, value: UserAdminTabType.EDIT_USERS },
  { label: t`Customize Roles`, value: UserAdminTabType.CUSTOMIZE_ROLES },
  { label: t`Change Permissions`, value: UserAdminTabType.CHANGE_PERMISSIONS },
  { label: t`Import Default Users`, value: UserAdminTabType.IMPORT_DEFAULT_USERS },
];
